import { render, staticRenderFns } from "./CreateShow.vue?vue&type=template&id=4bd21dbc&lang=pug&"
import script from "./CreateShow.vue?vue&type=script&lang=js&"
export * from "./CreateShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports